import actions from "./actions"

export default function contactsReducers(state = [], action: {payload: any, type: any}):any {
    switch (action.type){
        case actions.SET_DATA:
            return [...action.payload];
        case actions.SET_INITIAL_CONTACTS:
            return []
        default:
            return state
    }
}